// src/components/Admin/PlantList.js

import React, { useEffect, useState } from 'react';
import { getPlants } from '../../services/plantService';
import AddEditPlantForm from './AddEditPlantForm';

function PlantList() {
    const [plants, setPlants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedPlant, setSelectedPlant] = useState(null);

    useEffect(() => {
        fetchPlants();
    }, []);

    const fetchPlants = () => {
        setLoading(true);
        getPlants()
            .then((response) => {
                setPlants(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };

    const handleAddPlant = () => {
        setSelectedPlant(null);
        setShowModal(true);
    };

    const handleEditPlant = (plant) => {
        setSelectedPlant(plant);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
        setSelectedPlant(null);
        fetchPlants(); // Refresh the plant list
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen text-xl">
                Loading...
            </div>
        );
    }

    return (
        <div className="min-h-screen p-8 bg-gray-100">
        <div className="container mx-auto px-4 py-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">Plants</h1>
                <button
                    onClick={handleAddPlant}
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                >
                    Add New Plant
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {plants.map((plant) => (
                    <div key={plant.plant_id} className="bg-white rounded shadow p-4">
                        <img
                            src={plant.picture_url}
                            alt={plant.name}
                            className="w-full h-48 object-cover rounded mb-4"
                        />
                        <h2 className="text-2xl font-bold mb-2">{plant.name}</h2>
                        <p className="text-gray-600 italic mb-2">{plant.botanical_name}</p>
                        <p className="text-gray-700 mb-2">
                            {plant.description.length > 100
                                ? plant.description.substring(0, 100) + '...'
                                : plant.description}
                        </p>
                        <p className="text-gray-500 mb-2">
                            <strong>Category:</strong> {plant.category.name}
                        </p>
                        <p className="text-gray-500 mb-4">
                            <strong>Availability:</strong>{' '}
                            {plant.is_availability ? 'Available' : 'Not Available'}
                        </p>
                        <button
                            onClick={() => handleEditPlant(plant)}
                            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                            Edit
                        </button>
                    </div>
                ))}
            </div>

            {showModal && (
                <AddEditPlantForm
                    plant={selectedPlant}
                    onClose={handleModalClose}
                />
            )}
        </div>
        </div>
    );
}

export default PlantList;
